import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';
import {LanguageEnum} from '@core/enums/language.enum';

@Component({
    selector: 'app-wizard-step-indications',
    templateUrl: './wizard-step-indications.component.html',
    styleUrls: ['./wizard-step-indications.component.scss']
})
export class WizardStepIndicationsComponent {

    @Input() userPresetIndicationId: string;
    @Input() indications: IndicationBasicModel[] | undefined;
    @Input() language: LanguageEnum | undefined;
    @Output() nextStepEvent: EventEmitter<string> = new EventEmitter();
    @Output() indicationSelectedClickEvent: EventEmitter<IndicationBasicModel> = new EventEmitter();
    disabled = true;

    nextStepClick(id: string): void {
        this.nextStepEvent.emit(id);
    }

    indicationSelectedClick(indication: IndicationBasicModel): void {
        this.indicationSelectedClickEvent.emit(indication);
    }
}
